import React from 'react';
import { ProfileOutlined, RightOutlined, ToolOutlined } from '@ant-design/icons';
import { Row, Col } from 'antd';
import OnTraccrButton from '../../../../../common/buttons/OnTraccrButton';
import useToggle from '../../../../../common/hooks/useToggle';
import TimeTrackingGridWizardAddMemberDrawer from './TimeTrackingGridWizardAddMemberDrawer';

export default function TimeTrackingGridWizardUserEquipmentStep({
  goToNextStep,
  divisions,
  selectedUsers,
  setSelectedUsers,
  selectedEquipment,
  setSelectedEquipment,
}) {
  const { toggle: toggleAddUsersDrawer, isToggled: showAddUsersDrawer } = useToggle();
  const { toggle: toggleAddEquipmentDrawer, isToggled: showAddEquipmentDrawer } = useToggle();

  return (
    <div className="time-tracking-grid-wizard-date-step-container">
      <div className="time-tracking-grid-content-title">Step 3: Add Users & Equipment</div>
      <div className="time-tracking-grid-content-description">
        Users and equipment become the rows of your grid. Add the people and equipment that need hours allocated.
      </div>
      <div className="time-tracking-grid-sub-content">
        <Row style={{ width: '80%' }} gutter={10}>
          <Col span={12}>
            <div className="time-tracking-grid-wizard-costcode-step-count">{selectedUsers?.length || 0}</div>
            <div className="time-tracking-grid-wizard-costcode-step-count-text">Users</div>
            <OnTraccrButton
              title="Add Users"
              iconLeft
              icon={<ProfileOutlined />}
              className="time-tracking-grid-wizard-content-button"
              type="primary"
              onClick={toggleAddUsersDrawer}
            />
          </Col>
          <Col span={12}>
            <div className="time-tracking-grid-wizard-costcode-step-count">{selectedEquipment?.length || 0}</div>
            <div className="time-tracking-grid-wizard-costcode-step-count-text">Equipment</div>
            <OnTraccrButton
              title="Add Equipment"
              iconLeft
              icon={<ToolOutlined />}
              className="time-tracking-grid-wizard-content-button"
              type="cancel"
              onClick={toggleAddEquipmentDrawer}
            />
          </Col>
          <OnTraccrButton
            title="Build Grid"
            onClick={goToNextStep}
            icon={<RightOutlined />}
            className="time-tracking-grid-wizard-content-button"
            disabled={!selectedUsers?.length && !selectedEquipment?.length}
          />
        </Row>
      </div>
      <TimeTrackingGridWizardAddMemberDrawer
        variant="user"
        visible={showAddUsersDrawer}
        onClose={toggleAddUsersDrawer}
        selectedRows={selectedUsers}
        setSelectedRows={setSelectedUsers}
        divisions={divisions}
      />
      <TimeTrackingGridWizardAddMemberDrawer
        variant="equipment"
        visible={showAddEquipmentDrawer}
        onClose={toggleAddEquipmentDrawer}
        selectedRows={selectedEquipment}
        setSelectedRows={setSelectedEquipment}
        divisions={divisions}
      />
    </div>
  );
}
